const EULA_BASE_BY_ENV = {
    dev: 'https://login-dev.pearson.com/v1/piapi-dev/login/static/html',
    test: 'https://login-qa.pearson.com/v1/piapi-test/login/static/html',
    stage: 'https://login-stg.pearson.com/v1/piapi-int/login/static/html',
    ppe: 'https://login-ppe.pearson.com/v1/piapi-pqa/login/static/html',
    prod: 'https://login.pearson.com/v1/piapi/login/static/html'
};

const DEFAULT_EULA_FILENAME = 'PearsonEULA.html';
const EULA_FILENAME_PATTERN = /PearsonEULA[^?#]*/i;

export function resolvePearsonEulaEnvironment (iamHostname) {
    const host = (iamHostname || '').trim().toLowerCase();

    if (host.includes('iam-dev') || host.includes('-dev.')) {
        return 'dev';
    }
    if (host.includes('iam-test') || host.includes('-test.')) {
        return 'test';
    }
    if (host.includes('iam-stage') || host.includes('-stage.')) {
        return 'stage';
    }
    if (host.includes('iam-ppe') || host.includes('-ppe.')) {
        return 'ppe';
    }

    return 'prod';
}

export function getPearsonEulaBaseUrl (iamHostname = window.location.hostname) {
    return EULA_BASE_BY_ENV[resolvePearsonEulaEnvironment(iamHostname)];
}

export function buildPearsonEulaUrl (filename = DEFAULT_EULA_FILENAME, iamHostname = window.location.hostname) {
    const eulaFilename = EULA_FILENAME_PATTERN.test(filename) ? filename : DEFAULT_EULA_FILENAME;
    return `${getPearsonEulaBaseUrl(iamHostname)}/${eulaFilename}`;
}

export function getDefaultPearsonEulaUrl (iamHostname = window.location.hostname) {
    return buildPearsonEulaUrl(DEFAULT_EULA_FILENAME, iamHostname);
}

export function normalizePearsonEulaUrl (url, iamHostname = window.location.hostname) {
    if (!url) {
        return url;
    }

    const match = url.match(EULA_FILENAME_PATTERN);
    if (!match) {
        return url;
    }

    return buildPearsonEulaUrl(match[0], iamHostname);
}

function normalizeLocaleKey (key) {
    return String(key || '').trim().replace(/_/g, '-').toLowerCase();
}

export function pickUrlFromUrlsByLanguage (urlsByLanguage, userLocale) {
    if (!urlsByLanguage?.length || !userLocale) {
        return null;
    }

    const keyToUrl = new Map();
    for (const entry of urlsByLanguage) {
        for (const [key, url] of Object.entries(entry)) {
            keyToUrl.set(normalizeLocaleKey(key), url);
        }
    }

    const norm = normalizeLocaleKey(userLocale);
    const parts = norm.split('-').filter(Boolean);
    const candidates = [norm];
    if (parts.length > 1) {
        candidates.push(parts[0]);
    }

    for (const candidate of candidates) {
        const url = keyToUrl.get(candidate);
        if (url) {
            return url;
        }
    }

    return null;
}

export function resolveTermsPolicyUrl (policy, locale, iamHostname = window.location.hostname) {
    const url = pickUrlFromUrlsByLanguage(policy.urlsByLanguage, locale) || policy.policyRef;
    return normalizePearsonEulaUrl(url, iamHostname);
}
